"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAnalysisResultOutputDtoSchema = exports.updateAnalysisResultInputDtoSchema = void 0;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const zod_preprocessors_js_1 = require("../utils/zod-preprocessors.js");
const updateAnalysisResultInput = {
    id: zod_1.z.string(),
    statusOverride: sigma_engine_shared_1.RequirementInstanceResultOverrideStatusSchema.nullable().optional(),
    isReviewed: zod_1.z.boolean().optional(),
};
exports.updateAnalysisResultInputDtoSchema = zod_1.z.object(updateAnalysisResultInput);
const updateAnalysisResultOutput = {
    result: zod_1.z.preprocess(zod_preprocessors_js_1.preprocessResult, sigma_engine_shared_1.RequirementInstanceResultSchema),
};
exports.updateAnalysisResultOutputDtoSchema = zod_1.z.object(updateAnalysisResultOutput);
//# sourceMappingURL=update-analysis-result.dto.js.map